var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-copyright"},[_c('h1',[_vm._v("© Copyright 2022 - Ing. Beimar Apaza A. - Cel: 77120645")])])}]

export { render, staticRenderFns }